<template>
  <section id="workPlaceSelection" class="workPlaceSelection">
       <div class="">
     <!--       <video poster="/path/to/poster.jpg" id="player" playsinline controls>
    <source src="static/1529992484017rajlokare.com@gmail.com_Q1_videoBioData.mp4" type="video/mp4">
 
</video> -->

<div class="plyr__video-embed" id="player">
   <!--  <iframe  src="static/1528695197156addi.ghogare@gmail.com_Q2_videoBioData.mp4" id="video-container" width="100%" height="450"></iframe> -->
   <!--  <iframe  src="static/1529992484017rajlokare.com@gmail.com_Q1_videoBioData.mp4" id="video-container" width="100%" height="450"></iframe> -->
   
   <video-player  class="video-player-box"
                 ref="videoPlayer"
                 :options="playerOptions"
                 :playsinline="true"
                 customEventName="customstatechangedeventname"

                 @play="onPlayerPlay($event)"
                 @pause="onPlayerPause($event)"
                 @ended="onPlayerEnded($event)"
                 @waiting="onPlayerWaiting($event)"
                 @playing="onPlayerPlaying($event)"
                 @loadeddata="onPlayerLoadeddata($event)"
                 @timeupdate="onPlayerTimeupdate($event)"
                 @canplay="onPlayerCanplay($event)"
                 @canplaythrough="onPlayerCanplaythrough($event)"

                 @statechanged="playerStateChanged($event)"
                 @ready="playerReadied">
  </video-player>
    </div>
    </div>
  </section>
</template>
<script>
import { videoPlayer } from 'vue-video-player'
export default {
  name: 'videoUpload',
  components: {videoPlayer},
  data () {
    return {
      playerOptions: {
        // videojs options
        muted: true,
        language: 'en',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [{
          type: 'video/mp4',
          src: 'http://staging-applymfs.mkcl.org/cdn/ERA/data/MFSFramework/data/2018/documents/videoBioData/hiteshb@mkcl.org/1527837986662hiteshb@mkcl.org_Q1_videoBioData.mp4'
        }],
        poster: '/static/images/author.jpg'
      }
    }
  },
  mounted () {
    console.log('this is current player instance object', videoPlayer)
  },
  computed: {
    player () {
      return this.$refs.videoPlayer.player
    }
  },
  methods: {
    // listen event
    onPlayerPlay (player) {
      // console.log('player play!', player)
    },
    onPlayerPause (player) {
      // console.log('player pause!', player)
    },
    // ...player event
    // or listen state event
    playerStateChanged (playerCurrentState) {
      // console.log('player current update state', playerCurrentState)
    },
    // player is ready
    playerReadied (player) {
      console.log('the player is readied', player)
      // you can use it to do something...
      // player.[methods]
    }
  }
}
</script>

<style lang="scss">
.workPlaceSelection{  
.selectedItem{


  .mdi-delete{font-size:19px; color:#888; &:hover{color:#555;}}
  .mdi-checkbox-marked-circle{
    color:#8acc10;
     font-size:24px;
 vertical-align: middle;
 padding-left:10px;
  }
  .mdi-chevron-up{
    color:#72a711;
    padding-left:10px;
    padding-right:10px;
    cursor: pointer;
     font-size:24px;
 vertical-align: middle;
 padding-left:10px;
  }
  .mdi-chevron-down{
    color:#ff4949;
    padding-left:10px;
    padding-right:10px;
    cursor: pointer;
     font-size:24px;
 vertical-align: middle;
 padding-left:10px;
  }
  
}
    .vb > .vb-dragger {
    z-index: 5;
    width: 12px;
    right: 0;
}
.grey{color:#999;}
.bigtext{
  opacity:0.2;
  font-size:30px;
  font-weight:600;
  padding-top:20px;
  padding-left:0px;
}

// slide
 .card-alt {
    // margin:0px;
    padding: 40px;
    min-height: 600px;
    margin-bottom:80px;
    // box-shadow: none;
  }
  .card-alt-body {
    padding-top: 0px;
  }
  .card-alt-header {
    padding-left: 15px;
    padding-top: 40px;
    padding-bottom: 10px;
  }
  .slide-leave-to{
    transform: translateX(-100%);
    opacity:0.5;
  }
  .slide-enter{
    transform: translateX(-100%);
     opacity:0.5;
  }
  .slide-enter-to, .slide-leave{
    opacity:1;transform: translateY(50%); 
  }
  .slide-enter-active, .slide-leave-active{
    transition: all 200ms ease-in-out;
  }
  // sleek
  .sleek-leave-to{
    transform: translateX(100%);
    opacity:0.5;
    transform: translateY(20%);
  }
  .sleek-enter{
    transform: translateX(50%);
    transform: translateY(20%); 
     opacity:0.5;
  }
  .sleek-enter-to{
    opacity:1;
    
    //  transform: translateX(100%);
  }
  .sleek-leave{
    opacity:0.5;
    // transform: translateY(50%); 
    // transform: translateX(100%);
    
  }
  .sleek-enter-active, .sleek-leave-active{
    transition: all 100ms ease-in-out;
  }
.vb > .vb-dragger > .vb-dragger-styler {
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    -webkit-transform: rotate3d(0,0,0,0);
    transform: rotate3d(0,0,0,0);
    -webkit-transition:
        background-color 100ms ease-out,
        margin 100ms ease-out,
        height 100ms ease-out;
    transition:
        background-color 100ms ease-out,
        margin 100ms ease-out,
        height 100ms ease-out;
    background-color: rgba(194, 195, 197, 0.3);
    // margin: 5px 5px 5px 0;
    margin:0;
    border-radius: 20px;
    height: calc(100% - 10px);
    display: block;
}
.vb-dragger{background-color: rgba(194, 195, 197, 0); margin:0px;   height: 90%;}
.vb.vb-scrolling-phantom > .vb-dragger > .vb-dragger-styler {
    background-color: rgba(194, 195, 197, 0.3);
     height: 100%;
}

.vb > .vb-dragger:hover > .vb-dragger-styler {
    background-color: rgba(194, 195, 197, 0.3);
    margin: 0px;
    height: 100%;
}

.vb.vb-dragging > .vb-dragger > .vb-dragger-styler {
    background-color: rgba(194, 195, 197, 0.3);
    margin: 0px;
    height: 100%;
}

.vb.vb-dragging-phantom > .vb-dragger > .vb-dragger-styler {
    background-color: rgba(194, 195, 197, 0.3);
    margin:0px;
     height: 100%;
}

.panel__body{
padding-left:15px;
padding-right:15px;
}
.panel__heading{
  padding-bottom:10px;
  .input-group{    
    border: 1px solid #f2f2f2;
    box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.1);
    padding: 0;
   border-radius:5px;
    .input-group-addon{
       background: #fff;padding: 10px;line-height: 25px;   
      .mdi{font-size:20px; display: inline-block; margin-top:-9px; color:#6C757D;}
    }
    .form-control{
      background-color:transparent;
          
    font-family: inherit;
    font-weight: 500;
    background: #fff;
    color: inherit;
    box-shadow: none;
    border:none;
    }
  }
}

.list-wrap{
  height: 450px;
  scroll-behavior: auto;
}
.list-css{
  padding:7px 15px;
  background-color:#fff;
  margin-bottom:10px;
  transition: all 200ms ease-in-out;
  border-radius:3px;
  transition: 300ms ease;
  &:hover{
    box-shadow: 2px 2px 15px rgba(0, 0, 0, 0.1);
  }
  .col-auto{
    .btn{visibility: hidden; font-size:12px; padding:9px 26px; background-color:transparent; border:none;}
  }
  &:hover{
   .btn{visibility: visible; background-color:#8acc10;}
  }
}
.list-checked{
  padding:7px 15px;
  background-color:#ececec;
  margin-bottom:10px;
  transition: all 200ms ease-in-out;
  border-radius:3px; 

  &:hover{
       box-shadow: 2px 2px 15px rgba(0, 0, 0, 0.1);
  }
}
.list-checked1{
  padding:7px 15px;
  background-color:#fff;
  margin-bottom:10px;
  transition: all 200ms ease-in-out;
  border-radius:3px;
  transition: 300ms ease;
  &:hover{
    box-shadow: 2px 2px 15px rgba(0, 0, 0, 0.1);
  }
  .col-auto{
    .btn{visibility: hidden; font-size:12px; padding:9px 26px; background-color:transparent; border:none;}
  }
  &:hover{
   .btn{visibility: visible; background-color:#8acc10;}
  }
}
   .card-alt {
    // margin:0px;
    padding: 40px;
    min-height: 600px;
    margin-bottom:80px;
    // box-shadow: none;
  }
  .card-alt-body {
    padding-top: 0px;
  }
  .card-alt-header {
    padding-left: 15px;
    padding-top: 40px;
    padding-bottom: 10px;
  }
  .input-group{
    
    border: 1px solid #f2f2f2;
    box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.1);
    padding: 0;
   border-radius:5px;
    .input-group-addon{
       background: #fff;padding: 10px;line-height: 25px;   
      .mdi{font-size:20px; display: inline-block; margin-top:-9px; color:#6C757D;}
    }
    .form-control{
      background-color:transparent;
          
    font-family: inherit;
    font-weight: 500;
    background: #fff;
    color: inherit;
    box-shadow: none;
    border:none;
    }
  }
      .card-sec{
          
        margin-top:30px;
        margin-bottom:50px;
            .card-course{
              margin-bottom:40px;
                padding-top:30px;
                padding:20px;
                transition: all 0.3s cubic-bezier(.25,.8,.25,1);
                box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);  
                border-radius: 5px;
                border:1px solid #fff;
                background: #fff; 
                // transition: 300ms ease; transition: 300ms ease; position: relative;
                &:hover {
                    box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
                    // .btn{background: lighten(#4885ed,22%); color:#4885ed; font-weight:600; letter-spacing: 0.2px;}
                }
                hr{border-color:transparent;}
                .ctitle{font-size:18px; font-weight: 400;}
                .utitle{font-size:14px;}
                .btn{
                    border:none; 
                    padding:8px 28px; 
                    // font-size:11px; 
                    margin-right:10px;
                    &:hover{box-shadow: none; }
                }
                .course-icon{
                      position: absolute;
                      bottom: 52px;
                      right: 34px;
                      font-size: 23px;
                      color: #f1f1f1;
                      z-index: 0
                }
                .card-data{
                  position: relative;
                  z-index: 101;
                }
            }
        }
        .help{font-size:11px; word-spacing: 1px; padding-left:12px;text-transform: uppercase; }
        .red{color:#ec4343; padding-left:15px;}
        .v-select {
            .dropdown-toggle {
            z-index: 3;
            
            border-left: 0px;
            border-right: 0px;
            border-top: 0px;
            padding-left: 0px;
            border-radius: 0px;
            font-family: 'Open Sans';
            font-weight: 600;
            border-color:#ddd;
            .clear {
                line-height: 20px;
            }
            }
            .dropdown-menu {
            z-index:3;
            // box-shadow: none;
            font-family: 'Open Sans';
            border-radius: 5px;
            font-size: 14px;
            border: none;
            box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.2);
            }
            .selected-tag {
            color: #495057;
            font-size: 18px;
            font-weight: 500;
            letter-spacing: 0.25px;
            }
        }
          .custom-input {
    z-index:2;
    input::placeholder {
      /* Chrome, Firefox, Opera, Safari 10.1+ */
      color: #37474f;
      opacity: 1; /* Firefox */
    }

    :-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: #37474f;
    }

    ::-ms-input-placeholder {
      /* Microsoft Edge */
      color: #37474f;
    }
    // border:0px solid #ddd;
    padding: 15px;
    margin-bottom: 0;
    label {
      font-size: 11px;
      color: #37474f;
      text-transform: uppercase;
      margin-bottom: 0;
      padding-left: 10px;
    }
   
    }
}
.paraFont{
  font-size: 14px;
}
.subInstructionFont{
  font-size: 12px;
}
.height{
  line-height: 2.0;
  font-weight: 500;
}

.doc-upload{
  .title{
    // font-size:1px;
    margin-top:30px;
        font-weight: 500;
    // font-size: 18px;
    // color: #78838e;
    display: block;

  }
  .vue-dropzone{
    border:2px dashed #bbb;
    margin-top:10px;
    font-family: 'Open Sans';
    // font-size:13px;
    padding-top:25px;
    margin-bottom:0px;
    background-color:#f7f7f7;
    border-radius:5px;
    // padding-right:50px;
     .dz-preview .dz-details {
      bottom: 0;
      margin-right:30px;
      top: 0;
      color: #555;
      // background-color: #fff;
      background-color:#fff;
      transition: opacity .2s linear;
      text-align: left;
      border-radius:4px;
        
    }
    .dz-remove {
          position: absolute;
          z-index: 30;
          color: white;
          background-color: #aaa;
          margin-left: 15px;
          padding: 10px 20px;
          top: inherit;
          bottom: 15px;
          border-radius:20px;
          border: none;
          text-decoration: none;
          text-transform: uppercase;
          font-size: 12px;
          font-family: 'Open Sans';
          font-weight: 600;
          letter-spacing:0.4px;
          opacity: 0;
          &:hover{text-decoration: none; background-color:#999;}
      }
    &:hover{background-color:#eee;}
  }
}
.loader-wraper{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 101;
  background: rgba(255,255,255,0.7);
  animation: fadeIn  0.5s ease-in-out;
  .loader-box{
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color:  #607D8B;

  }
  .lds-roller {
  display: block;
  position: relative;
  width: 64px;
  height: 64px;
  margin: 0 auto;
}
.lds-roller div {
  animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  transform-origin: 32px 32px;
}
.lds-roller div:after {
  content: " ";
  display: block;
  position: absolute;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #607D8B;
  margin: -3px 0 0 -3px;  
}
.lds-roller div:nth-child(1) {
  animation-delay: -0.036s;
}
.lds-roller div:nth-child(1):after {
  top: 50px;
  left: 50px;
}
.lds-roller div:nth-child(2) {
  animation-delay: -0.072s;
}
.lds-roller div:nth-child(2):after {
  top: 54px;
  left: 45px;
}
.lds-roller div:nth-child(3) {
  animation-delay: -0.108s;
}
.lds-roller div:nth-child(3):after {
  top: 57px;
  left: 39px;
}
.lds-roller div:nth-child(4) {
  animation-delay: -0.144s;
}
.lds-roller div:nth-child(4):after {
  top: 58px;
  left: 32px;
}
.lds-roller div:nth-child(5) {
  animation-delay: -0.18s;
}
.lds-roller div:nth-child(5):after {
  top: 57px;
  left: 25px;
}
.lds-roller div:nth-child(6) {
  animation-delay: -0.216s;
}
.lds-roller div:nth-child(6):after {
  top: 54px;
  left: 19px;
}
.lds-roller div:nth-child(7) {
  animation-delay: -0.252s;
}
.lds-roller div:nth-child(7):after {
  top: 50px;
  left: 14px;
}
.lds-roller div:nth-child(8) {
  animation-delay: -0.288s;
}
.lds-roller div:nth-child(8):after {
  top: 45px;
  left: 10px;
}
@keyframes lds-roller {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

}

@keyframes fadeIn {
    from {opacity: 0;}
    to {opacity: 1;;}
}
.title img{
  width: 100%;
}
.photo{
  width:150px;
}
.sign{
  width:150px;;
}
.green{
  color: rgb(7, 119, 44)
}

// instruction starts here
    .download-card {
        box-shadow: 12px 15px 20px 0 rgba(46, 61, 73, .15);
        background: #fff;
        padding: 21px;
        border-radius: 6px;
        margin-bottom: 10px;
        /* font-size: 13px;
        font-weight: 50; */
    }
    .download-card .mdi{
  font-size: 14px;
}
    .instruction-title{
      color: #333;
      font-size: 20px;
      color: #2e3d49;
    }
    .btn-circle {
        width: 30px;
        height: 30px;
        text-align: center;
        padding: 6px 0;
        font-size: 12px;
        line-height: 1.428571429;
        border-radius: 15px;
        background: #02b3e4;
        color: #fff;
        box-shadow: 5px 5px 25px 0 rgba(46, 61, 73, .2);
        margin-bottom: 10px;
        transition: all .2s ease-in;
    }
 .btn-circle.btn-xs {
        width: 30px;
        height: 30px;
        padding: 4px 7px;
        font-size: 18px;
        line-height: 1.33;
        border-radius: 20px;
    }
    .btn-circle.btn-lg {
        width: 50px;
        height: 50px;
        padding: 10px 16px;
        font-size: 18px;
        line-height: 1.33;
        border-radius: 25px;
    }

    .btn-circle.btn-xl {
        width: 70px;
        height: 70px;
        padding: 10px 16px;
        font-size: 24px;
        line-height: 1.33;
        border-radius: 35px;
    }
    .btn-circle:hover{
      background:#71d102;
        color: #fff;
       
    }
    .download-card .zmdi {
        font-size: 20px;
        
    }
  
    .instructions li{
  
    	list-style-type: none;

    font-size: 15px;
    text-indent: -1.28571429em;
    }
    .instructions li:before {
    font-family: Material Design Icons;
    content: "\f2c7";
  color: #000;
    position: relative;
    padding-right: 10px;
    top: -1px;
        list-style-position: inside;
}
.download-card .btn-text{
  font-size: 12px;
  font-weight: 700;
}
.video-card{
    box-shadow: 12px 15px 20px 0 rgba(46, 61, 73, .15);
        background: #fff;
        padding: 10px 25px;
        border-radius: 6px;
        margin-bottom: 30px;
}
.video-card p{
  margin-bottom: 0;
}
.video-card .dropzone{
  min-height:50px;
  padding:0;
}
.video-card .dropzone .dz-message {

    margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/videoUpload/videoUpload.vue